module.exports = __webpack_public_path__ + "img/shipSubscrib_menu_tooltip.ca3341bd.svg";